import createModel from './lib/create_model';

const prop = createModel.prop;

export default createModel({
  modelName: 'AgentAssistanceConfig',

  properties: {
    topicSuggestions: prop(Boolean).default(false),
    answerSuggestions: prop(Boolean).default(false),
  },

  isEnabled(feature) {
    return this[feature];
  },

  statics: {
    create() {
      return new this();
    },
  },
});



// WEBPACK FOOTER //
// ./src/scripts/domain/models/agent_assistance_config.js